import ShInputNumber from './src/main.vue'

ShInputNumber.install = Vue => {
  Vue.component(ShInputNumber.name, ShInputNumber)
}
export default ShInputNumber
